import React, { useEffect, useRef, useState } from 'react'
import { InputDiv, Label, Input, SearchOptions, Option } from '../../styles/select-style'
import axios from '../../../config/axios'
import { PropsType, StageType } from './types'

const SelectStageInService:React.FC<PropsType> = ({service, setService}) => {
  const [ items, setItems ] = useState<StageType[]>([])
  const [ inputItem, setInputItem ] = useState<string>('')
  const [ showOptions, setShowOptions ] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const optionsRef = useRef<HTMLUListElement>(null)
  const [ selectedIndex, setSelectedIndex ] = useState(0)
  
  useEffect(() => {
    console.log('🔵 [SelectStageInService] Componente montado')
    setSelectedIndex(0)
    console.log('🔵 [SelectStageInService] Fazendo requisição para buscar stages...')
    axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/service/utils/stages`)
      .then(response => {
        console.log('✅ [SelectStageInService] Stages recebidos:', response.data)
        if(response.data) {
          setItems(response.data)
          console.log('✅ [SelectStageInService] Items atualizados:', response.data.length, 'itens')
        }
      })
      .catch(error => {
        console.error('❌ [SelectStageInService] Erro ao buscar stages:', error)
      })
  }, [])
  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        optionsRef.current &&
        inputRef.current &&
        !optionsRef.current.contains(target) &&
        !inputRef.current.contains(target)
      ) {
        setShowOptions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputItem(e.target.value)
    setSelectedIndex(0)
  }

  const handleSelectItem = (item:StageType) => {
    console.log('🟢 [SelectStageInService] handleSelectItem chamado com:', item)
    console.log('🟢 [SelectStageInService] Stages atuais:', service.stages)
    
    if (service.stages.some(s => s.id === item.id)) {
      console.log('⚠️ [SelectStageInService] Stage já existe, ignorando')
      return
    }
    
    console.log('🟢 [SelectStageInService] Adicionando stage:', item.name)
    setService(prev => {
      const newStages = [...prev.stages, {id: item.id, name: item.name}]
      console.log('🟢 [SelectStageInService] Novos stages:', newStages)
      return {...prev, stages: newStages}
    })
    setShowOptions(false)
    setInputItem('')
    console.log('🟢 [SelectStageInService] Stage adicionado com sucesso')
  }
  
  const filteredItems = items.filter(item => 
    item.name.toLowerCase().includes(inputItem.toLowerCase())
  )
  
  const handleSetOptionByKey = (e:React.KeyboardEvent) => {
    if(e.key === 'ArrowDown' && selectedIndex < filteredItems.length - 1) setSelectedIndex(prev => prev + 1)
    if(e.key === 'ArrowUp' && selectedIndex > 0) setSelectedIndex(prev => prev - 1)
    if(e.key === 'Enter' && filteredItems[selectedIndex]) handleSelectItem(filteredItems[selectedIndex])
    if(e.key === 'Tab') setShowOptions(false)
  }

  return(
    <InputDiv>
      <Label>Etapa(s)</Label>
      <Input 
        ref={inputRef}
        type='text' 
        placeholder='Escolha uma etapa'
        value={inputItem}
        onFocus={() => {
          console.log('🟡 [SelectStageInService] Input recebeu foco')
          console.log('🟡 [SelectStageInService] Items disponíveis:', items.length)
          console.log('🟡 [SelectStageInService] Filtered items:', filteredItems.length)
          setShowOptions(true)
        }}
        onChange={handleChangeInput}
        onKeyDown={(e) => handleSetOptionByKey(e)}
      />
      {showOptions && filteredItems.length > 0 && (
        <SearchOptions ref={optionsRef}>
          {filteredItems.map((s, index) => 
            <Option 
              key={s.id}
              onClick={(e) => {
                console.log('🟣 [SelectStageInService] Opção clicada:', s.name, 'index:', index)
                console.log('🟣 [SelectStageInService] Event:', e)
                e.preventDefault()
                e.stopPropagation()
                handleSelectItem(s)
              }}
              isSelected={index === selectedIndex}
            >
              {s.name}
            </Option>
          )}
        </SearchOptions>
      )}
      {showOptions && filteredItems.length === 0 && (
        <SearchOptions ref={optionsRef}>
          <Option>Nenhum resultado encontrado</Option>
        </SearchOptions>
      )}
    </InputDiv>
  )
}

export default SelectStageInService

